module.exports = __webpack_public_path__ + "assets/lessons/hr/lesson3/pages/lesson_3_05.pdf";